export default __webpack_public_path__ + "static/media/energyAirFlowLeft.e8a8da13.svg";